export const defaultMenuType = 'menu-default';
export const subHiddenBreakpoint = 512;
export const menuHiddenBreakpoint = 512;
export const defaultLocale = 'es';
export const localeOptions = [{ id: 'es', name: 'Español', direction: 'ltr' }, { id: 'en', name: 'English', direction: 'ltr' }];

export const adminRoot = '/app';
export const precioRoot = '/precio';
export const KPIRoot = '/kpi';
export const codificacionRoot = '/codificacion';
export const adminMiuRoot = '/admin';
export const marketIntelRoot = '/marketintel';
export const libraryRoot = '/library';
export const searchPath = `${adminRoot}/#`;


//export const servicePath = 'http://localhost:5001/unops-pharmamxapp-dev/us-central1/devmiu/'; //Local 
export const servicePath = 'https://us-central1-unops-pharmamxapp-dev.cloudfunctions.net/miu/'; //Produccion
//export const servicePath = 'https://us-central1-unops-pharmamxapp-dev.cloudfunctions.net/devmiu/'; //Desarrollo


export const currentUser = { id: 1, title: 'No definido', img: '/assets/img/profiles/l-1.jpg', date: 'Last seen today 15:24' }

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.blueyale';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isAuthGuardActive = true;
export const colors = ['blueyale'];

